export enum StudioMenuLabelEnum {
    DASHBOARD = 'Dashboard',
    MY_PROGRAMS = 'My Programs',
    MY_FORMATS = 'My Formats',
    MY_TRANSACTIONS = 'My Transactions',
    MY_LICENCES = 'My Licences',
}
